import { isTypeRelativeWithStartOnly, isTypeRelativeWithEnd } from "views/typeGuards/timeRange";
import assertUnreachable from "logic/assertUnreachable";
export const timeRangeToQueryParameter = (timeRange) => {
  switch (timeRange.type) {
    case "relative":
      if (isTypeRelativeWithStartOnly(timeRange)) {
        return { rangetype: "relative", relative: String(timeRange.range) };
      }
      if (isTypeRelativeWithEnd(timeRange)) {
        if ("to" in timeRange) {
          return { rangetype: "relative", from: String(timeRange.from), to: String(timeRange.to) };
        }
        return { rangetype: "relative", from: String(timeRange.from) };
      }
      return assertUnreachable(timeRange, "Unexpected time range: ");
    case "keyword":
      return { rangetype: "keyword", keyword: timeRange.keyword };
    case "absolute":
      return { rangetype: "absolute", from: timeRange.from, to: timeRange.to };
    default:
      return assertUnreachable(timeRange, "Unexpected time range type: ");
  }
};
const parseRelativeTimeRange = (range) => {
  const parseRangeValue = (rangeValue) => parseInt(rangeValue, 10);
  if ("relative" in range) {
    return { type: "relative", range: parseRangeValue(range.relative) };
  }
  if ("from" in range) {
    const result = { type: "relative", from: parseRangeValue(range.from) };
    if ("to" in range) {
      return { ...result, to: parseRangeValue(range.to) };
    }
    return result;
  }
  return assertUnreachable(range, "Invalid relative range specified: ");
};
export const timeRangeFromQueryParameter = (range) => {
  switch (range == null ? void 0 : range.rangetype) {
    case "relative":
      return parseRelativeTimeRange(range);
    case "absolute":
      return "from" in range && "to" in range ? {
        type: range.rangetype,
        from: range.from,
        to: range.to
      } : assertUnreachable(range, "Invalid absolute range specified: ");
    case "keyword":
      return "keyword" in range ? {
        type: range.rangetype,
        keyword: range.keyword,
        timezone: range.timezone
      } : assertUnreachable(range, "Invalid keyword range specified: ");
    default:
      return assertUnreachable(range, "Unsupported range type in range: ");
  }
};
